import { render, staticRenderFns } from "./TabelaCalculos.vue?vue&type=template&id=2a3c36fe&scoped=true&"
import script from "./TabelaCalculos.vue?vue&type=script&lang=js&"
export * from "./TabelaCalculos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCalculos.vue?vue&type=style&index=0&id=2a3c36fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c36fe",
  null
  
)

export default component.exports